angular.module('membership', [
    // 'ngSanitize',
])
.config(function($interpolateProvider, $locationProvider) {
    $interpolateProvider.startSymbol('{%');
    $interpolateProvider.endSymbol('%}');
    $locationProvider.html5Mode(true);
})
.controller('membershipCtrl', ['$scope', '$window', '$document', function($scope, $window, $document) {

    $scope.isReadyToSubmit = function () {

        return $scope.gdpr_1 && $scope.gdpr_2; // ..

    }

}]);

$('[type=tel]').mask('+000 000 000 00 00');

$(function () {
    $("#degree_granted").change(function() {
        var val = $(this).val();
        if(val === "Other") {
            $("#degree_granted_other").show();
        }
        else {
            $("#degree_granted_other").hide();
        }
    });
});

$(document).ready(function () {
    $("#degree_granted").trigger('change');
});
